import { createFileRoute } from '@tanstack/react-router'

import { PageCard, PageLayout } from '@/components/ui/page'

import { ItemCategoryCreateForm } from '@/features/item/components/item-category-form'

export const Route = createFileRoute('/_app/inventory/category/create')({
	component: RouteComponent,
})

function RouteComponent() {
	return (
		<PageLayout.Root>
			<PageLayout.Header
				breadcrumbs={[
					['/inventory', 'Inventory'],
					['/inventory/category', 'Kategori'],
					[Route.fullPath, 'Tambah kategori'],
				]}
			/>
			<PageCard.Root>
				<PageCard.Header title="Buat data master" />
				<ItemCategoryCreateForm />
			</PageCard.Root>
		</PageLayout.Root>
	)
}
